import { Quaternion, Vector3 } from '@babylonjs/core/Maths/math.vector';
import type { SceneObject, TraceScene } from '../../exports/scene';
import { resolveObjectRef, type Refusal } from '../../exports/editor';

export function applyTransform(
    transform: import('@babylonjs/core/Meshes/transformNode').TransformNode,
    position?: [number, number, number],
    rotation?: [number, number, number],
    scale?: [number, number, number],
): void {
    if (position) {
        transform.position = new Vector3(position[0], position[1], position[2]);
    }
    if (rotation) {
        const degToRad = Math.PI / 180;
        transform.rotationQuaternion = Quaternion.FromEulerAngles(
            rotation[0] * degToRad,
            rotation[1] * degToRad,
            rotation[2] * degToRad,
        );
    }
    if (scale) {
        transform.scaling = new Vector3(scale[0], scale[1], scale[2]);
    }
    if (position || rotation || scale) {
        transform.computeWorldMatrix(true);
    }
}

export function resolveUniqueByName(
    traceScene: TraceScene,
    nameOrPath: string,
    kind: string,
): SceneObject {
    const result = resolveObjectRef(traceScene, typeof nameOrPath === 'string' ? nameOrPath : '');
    if ('object' in result) return result.object;
    if (result.error === 'NOT_FOUND') throw new Error(`${kind}: scene object "${nameOrPath}" not found.`);
    if (result.error === 'AMBIGUOUS') throw new Error(`${kind}: name ${result.message}`);
    throw new Error(`${kind}: ${result.message}`);
}

/** A wiring refusal as a sentence; the prompt calls an event a graph already handles `event-conflict`. */
export function wiringRefusalText(refusal: Refusal): string {
    const sentence = /[.!?]$/.test(refusal.message) ? refusal.message : `${refusal.message}.`;
    return refusal.code === 'EVENT_CONFLICT' ? `event-conflict: ${sentence}` : sentence;
}
